import { spacer } from "../../assets/code-snippets/spacer/snip"
import Snippet from "../../components/Snippet/Snippet"

const Spacer = () => {

    return <div className="container fluid py-2" id="intro">
        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Spacer</p>
            <p className="text md">The element <code>poke-spacer</code> creates a space between a page content with a predefined height.</p>
        </div>

        <div className="spacer md"></div>

        <div className="row">
            <div className="col md-III">
                <div className="container md">
                    <Snippet code={spacer} language='html' />
                </div>
            </div>
            <div className="col md-III">
                <div className="container sm">
                    <div className="column gap-10">
                        <div className="spacer xs border-dark"></div>
                        <div className="spacer sm border-dark"></div>
                        <div className="spacer md border-dark"></div>
                        <div className="spacer lg border-dark"></div>
                        <div className="spacer xl border-dark"></div>
                        <div className="spacer xxl border-dark"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

}

export default Spacer